<template>
  <page>
    {{ $t('cms.PageNotFound') }}
  </page>
</template>

<script>
export default {
  name: 'not-found',
};
</script>
